import { ca } from '@cian/analytics';

export function trackGeoTagDeleted(type: string) {
  const getLabel = (type: string) => {
    switch (type) {
      case 'geoLocation':
        return 'region';
      case 'geoDistrict':
        return 'district';
      case 'geoStreet':
        return 'street';
      case 'geoUnderground':
        return 'metro';
      case 'geoRailway':
        return 'railways';
      case 'geoNewbuilding':
        return 'jk';
      default:
        return 'none';
    }
  };

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'delete_tag',
    label: `geo_${getLabel(type)}`,
  });
}

export function trackClearButtonClick(isAdvancedFiltersOpened: boolean | undefined) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'clear_filters',
    label: `From_cat${isAdvancedFiltersOpened ? '_fastfilters' : ''}`,
  });
}
